import React, { useState, useEffect, useRef } from 'react'
import ZenkliukoIkona from '../components/ZenkliukoIkona'
import { getAplankytos } from '../utils/aplankytos'
import { getPrisiminimai } from '../utils/prisiminimai'
import { skaiciuotiStatus } from '../utils/statai'
import { getIssukiai, getMatyti, pazymetiMatyta, KATEGORIJU_TVARKA } from '../utils/issukiai'

// Iššūkiai. Įveikti rodomi su švente iki KITO atidarymo, tada išsivalo.
function IssukiaiEkranas({ atidaryta, onClose, visosVietos }) {
  const [issukiai, setIssukiai] = useState([])
  const [matytiPries, setMatytiPries] = useState([]) // snapshot atidarymo metu
  const uzdirbtiIdRef = useRef([])

  useEffect(() => {
    if (!atidaryta) return
    const statai = skaiciuotiStatus(getAplankytos(), visosVietos, getPrisiminimai())
    const sarasas = getIssukiai(statai)
    setIssukiai(sarasas)
    setMatytiPries(getMatyti())
    uzdirbtiIdRef.current = sarasas.filter(i => i.uzdirbtas).map(i => i.id)
  }, [atidaryta, visosVietos])

  function uzdaryti() {
    // Pažymim visus dabar įveiktus kaip matytus — kitą kartą jų neberodysim
    if (uzdirbtiIdRef.current.length) pazymetiMatyta(uzdirbtiIdRef.current)
    onClose()
  }

  const matytiSet = new Set(matytiPries)
  const naujaiIveikti = issukiai.filter(i => i.uzdirbtas && !matytiSet.has(i.id))
  // Vykdomi = jau prasidėję (progresas > 0), bet dar neįveikti
  const vykdomi = issukiai.filter(i => !i.uzdirbtas && i.esamas > 0)
  // Galimi = dar neprasidėję (0 progreso), grupuojam pagal kategoriją
  const galimi = issukiai.filter(i => !i.uzdirbtas && i.esamas === 0)
  const galimiGrupes = KATEGORIJU_TVARKA
    .map(kat => ({ kat, elementai: galimi.filter(i => i.kategorija === kat) }))
    .filter(g => g.elementai.length > 0)

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1002, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 8px' }}>
        <button onClick={uzdaryti} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <span style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 19 }}>Iššūkiai</span>
        <div style={{ width: 34 }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '10px 16px calc(28px + env(safe-area-inset-bottom))' }}>

        {/* Įveikti (šventė) */}
        {naujaiIveikti.length > 0 && (
          <div style={{ marginBottom: 22 }}>
            <div style={{ color: '#7FB369', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>Įveikta! 🌲</div>
            {naujaiIveikti.map(i => (
              <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', borderRadius: 14, background: 'rgba(127,179,105,0.1)', border: '1px solid rgba(127,179,105,0.35)', marginBottom: 8 }}>
                <div style={{ width: 46, height: 46, borderRadius: '50%', flexShrink: 0, background: 'rgba(127,179,105,0.18)', border: '2px solid #7FB369', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ZenkliukoIkona ikona={i.ikona} dydis={22} spalva="#7FB369" />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#F0E8D5', fontSize: 15, fontFamily: "'Lora', Georgia, serif" }}>{i.pavadinimas}</div>
                  <div style={{ color: '#B0B8A8', fontSize: 12, marginTop: 2 }}>{i.aprasymas}</div>
                </div>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7FB369" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M20 6L9 17l-5-5" /></svg>
              </div>
            ))}
          </div>
        )}

        {/* Vykdomi (prasidėję) */}
        <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 10 }}>Vykdomi iššūkiai</div>
        {vykdomi.length === 0 ? (
          galimiGrupes.length === 0 ? (
            <p style={{ color: '#7A8A7E', fontSize: 13, textAlign: 'center', padding: '30px 20px', lineHeight: 1.6 }}>
              Visi iššūkiai įveikti! 🌲 Netrukus atsiras naujų.
            </p>
          ) : (
            <div style={{ padding: '16px 18px', borderRadius: 14, background: '#1E2E27', border: '1px dashed #3A4C42', marginBottom: 8, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <div style={{ width: 34, height: 34, borderRadius: '50%', flexShrink: 0, background: 'rgba(229,168,64,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ZenkliukoIkona ikona="compass" dydis={17} spalva="#E5A840" />
              </div>
              <div>
                <div style={{ color: '#F0E8D5', fontSize: 14, fontFamily: "'Lora', Georgia, serif", marginBottom: 4 }}>Kol kas nieko nepradėta</div>
                <p style={{ color: '#B0B8A8', fontSize: 12.5, lineHeight: 1.55, margin: 0 }}>
                  Aplankyk vietą ir žymėk „Buvau čia" — iššūkis prasidės savaime ir atsiras čia. Žemiau — ką gali pradėti.
                </p>
              </div>
            </div>
          )
        ) : vykdomi.map(i => {
          const proc = Math.round((i.esamas / i.tikslas) * 100)
          return (
            <div key={i.id} style={{ padding: '14px 16px', borderRadius: 14, background: '#1E2E27', border: '1px solid #2A3B32', marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 10 }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', flexShrink: 0, background: 'rgba(229,168,64,0.12)', border: '1px solid rgba(229,168,64,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ZenkliukoIkona ikona={i.ikona} dydis={20} spalva="#E5A840" />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: '#F0E8D5', fontSize: 15, fontFamily: "'Lora', Georgia, serif" }}>{i.pavadinimas}</div>
                  <div style={{ color: '#7A8A7E', fontSize: 12, marginTop: 2 }}>{i.aprasymas}</div>
                </div>
                <span style={{ color: '#E5A840', fontSize: 12, fontWeight: 500, flexShrink: 0 }}>{i.esamas}/{i.tikslas}</span>
              </div>
              <div style={{ height: 5, background: '#2A3B32', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ width: `${proc}%`, height: '100%', background: '#E5A840', transition: 'width 0.4s ease' }} />
              </div>
            </div>
          )
        })}

        {/* Ką gali pradėti — grupuota pagal kategoriją */}
        {galimiGrupes.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <div style={{ flex: 1, height: 1, background: '#2A3B32' }} />
              <span style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Ką gali pradėti</span>
              <div style={{ flex: 1, height: 1, background: '#2A3B32' }} />
            </div>
            {galimiGrupes.map(g => (
              <div key={g.kat} style={{ marginBottom: 16 }}>
                <div style={{ color: '#E5A840', fontSize: 11, fontWeight: 500, letterSpacing: '0.04em', marginBottom: 8 }}>{g.kat}</div>
                {g.elementai.map(i => (
                  <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 14px', borderRadius: 12, background: 'rgba(30,46,39,0.5)', border: '1px solid #2A3B32', marginBottom: 6 }}>
                    <div style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, background: '#1E2E27', border: '1px solid #3A4C42', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <ZenkliukoIkona ikona={i.ikona} dydis={17} spalva="#7A8A7E" />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ color: '#B0B8A8', fontSize: 14 }}>{i.pavadinimas}</div>
                      <div style={{ color: '#7A8A7E', fontSize: 11.5, marginTop: 2 }}>{i.aprasymas}</div>
                    </div>
                    <span style={{ color: '#7A8A7E', fontSize: 11, flexShrink: 0 }}>0/{i.tikslas}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default IssukiaiEkranas
